/**
 * Returns a sorted, deduplicated array of non-empty trimmed strings.
 */
export function uniqueLabels(values: string[]): string[] {
  return [...new Set(values.map((value) => value.trim()).filter(Boolean))].sort(
    (left, right) => left.localeCompare(right),
  );
}
